var React = require('react');

function Ridge (props) {
    return React.createElement("svg",props,[React.createElement("g",{"display":"none","key":0},React.createElement("rect",{"x":"7","y":"7","display":"inline","fill":"#000000","stroke":"#FF00FF","strokeWidth":"0.25","strokeMiterlimit":"10","width":"86","height":"86"})),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"d":"M26.661,93V7h2.724L73.34,50.955h-2.724L28.572,8.911V93H26.661z M57.239,93V79.623h2.723L73.34,93h-2.724L59.15,81.533    V93H57.239z"})))]);
}

Ridge.defaultProps = {"version":"1.0","x":"0px","y":"0px","viewBox":"0 0 100 100","enableBackground":"new 0 0 100 100","xmlSpace":"preserve"};

module.exports = Ridge;

Ridge.default = Ridge;
